import clsx from 'clsx'
import React from 'react'
import { useTranslation } from 'react-i18next'

import {
  ALGERIA_EMAIL,
  ALGERIA_EMAIL_LINK,
  ALGERIA_FACEBOOK_LINK,
  ALGERIA_INSTAGRAM_LINK,
  ALGERIA_PHONE,
  ALGERIA_PHONE_LINK,
  BECOME_A_DELIVERY_DRIVER_LINK,
  BECOME_A_DRIVER_LINK,
  BECOME_A_RESTAURANT_PARTNER_LINK,
  DOWNLOAD_THE_APP_LINK,
  MOROCCO_EMAIL,
  MOROCCO_EMAIL_LINK,
  MOROCCO_FACEBOOK_LINK,
  MOROCCO_INSTAGRAM_LINK,
  MOROCCO_PHONE,
  MOROCCO_PHONE_LINK,
  TUNISIA_EMAIL,
  TUNISIA_EMAIL_LINK,
  TUNISIA_FACEBOOK_LINK,
  TUNISIA_INSTAGRAM_LINK,
  TUNISIA_PHONE,
  TUNISIA_PHONE_LINK,
  WEBSITE_LINK
} from '@/components-latest/layout/Footer/Footer.constants'
import { Facebook, Instagram } from '@/components-latest/primitives/Icons'
import Text from '@/components-latest/primitives/Text/Text'

import styles from './Footer.module.scss'

const LinkItem = ({ label, href }: { label: string; href: string }) => (
  <li>
    <a href={href}>
      <Text className={styles.itemText} variant="body">
        {label}
      </Text>
    </a>
  </li>
)

const Footer: React.FC = () => {
  const { t } = useTranslation()

  return (
    <footer className={styles.footerContainer}>
      <div className={styles.footer}>
        <div className={styles.linksContainer}>
          <div>
            <Text
              className={styles.title}
              variant="body"
              asChild
              weight="extraBold">
              <h3>{t('footer.express-title')}</h3>
            </Text>
            <ul>
              <LinkItem
                label={t('footer.delivery-driver')}
                href={BECOME_A_DELIVERY_DRIVER_LINK}
              />
              <LinkItem
                label={t('footer.restaurant-partner')}
                href={BECOME_A_RESTAURANT_PARTNER_LINK}
              />
            </ul>
          </div>
          <div>
            <Text
              className={styles.title}
              variant="body"
              asChild
              weight="extraBold">
              <h3>{t('footer.yassir-title')}</h3>
            </Text>
            <ul>
              <LinkItem label={t('footer.website')} href={WEBSITE_LINK} />
              <LinkItem
                label={t('footer.download-app')}
                href={DOWNLOAD_THE_APP_LINK}
              />
              <LinkItem
                label={t('footer.become-driver')}
                href={BECOME_A_DRIVER_LINK}
              />
            </ul>
          </div>
          <div className={styles.download}>
            <Text
              className={styles.title}
              variant="body"
              asChild
              weight="extraBold">
              <h3>{t('footer.download-app')}</h3>
            </Text>
          </div>
        </div>

        <div className={styles.contactsContainer}>
          <div className={styles.cityContacts}>
            <Text
              className={clsx(styles.title, styles.mb20)}
              variant="nextSubtitle"
              weight="extraBold"
              asChild>
              <h3>{t('footer.contact-us')}</h3>
            </Text>
            <Text
              className={styles.title}
              variant="nextSubtitle"
              weight="extraBold"
              asChild>
              <h3>{t('footer.algeria')}</h3>
            </Text>
            <Text variant="body">
              <a
                className={styles.itemText}
                href={ALGERIA_PHONE_LINK}
                target="_blank"
                rel="noreferrer">
                {ALGERIA_PHONE}
              </a>
            </Text>
            <Text variant="body">
              <a
                className={styles.itemText}
                href={ALGERIA_EMAIL_LINK}
                target="_blank"
                rel="noreferrer">
                {ALGERIA_EMAIL}
              </a>
            </Text>
            <div className={styles.socialsRow}>
              <a href={ALGERIA_FACEBOOK_LINK}>
                <Facebook height={14} className={styles.icon} target="_blank" />
              </a>
              <a href={ALGERIA_INSTAGRAM_LINK}>
                <Instagram
                  height={14}
                  className={styles.icon}
                  target="_blank"
                />
              </a>
            </div>
          </div>

          <div className={styles.cityContacts}>
            <Text
              className={styles.title}
              variant="nextSubtitle"
              weight="extraBold"
              asChild>
              <h3>{t('footer.tunisia')}</h3>
            </Text>
            <Text variant="body">
              <a
                className={styles.itemText}
                href={TUNISIA_PHONE_LINK}
                target="_blank"
                rel="noreferrer">
                {TUNISIA_PHONE}
              </a>
            </Text>
            <Text variant="body">
              <a
                className={styles.itemText}
                href={TUNISIA_EMAIL_LINK}
                target="_blank"
                rel="noreferrer">
                {TUNISIA_EMAIL}
              </a>
            </Text>
            <div className={styles.socialsRow}>
              <a href={TUNISIA_FACEBOOK_LINK} target="_blank" rel="noreferrer">
                <Facebook height={14} className={styles.icon} />
              </a>
              <a href={TUNISIA_INSTAGRAM_LINK} target="_blank" rel="noreferrer">
                <Instagram height={14} className={styles.icon} />
              </a>
            </div>
          </div>

          <div className={styles.cityContacts}>
            <Text
              className={styles.title}
              variant="nextSubtitle"
              weight="extraBold"
              asChild>
              <h3>{t('footer.morocco')}</h3>
            </Text>
            <Text variant="body">
              <a
                className={styles.itemText}
                href={MOROCCO_PHONE_LINK}
                target="_blank"
                rel="noreferrer">
                {MOROCCO_PHONE}
              </a>
            </Text>
            <Text variant="body">
              <a
                className={styles.itemText}
                href={MOROCCO_EMAIL_LINK}
                target="_blank"
                rel="noreferrer">
                {MOROCCO_EMAIL}
              </a>
            </Text>
            <div className={styles.socialsRow}>
              <a href={MOROCCO_FACEBOOK_LINK} target="_blank" rel="noreferrer">
                <Facebook height={14} className={styles.icon} />
              </a>
              <a href={MOROCCO_INSTAGRAM_LINK} target="_blank" rel="noreferrer">
                <Instagram height={14} className={styles.icon} />
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer
